import { useState } from 'react';
import { Table, Checkbox, Segmented } from 'antd';
import { StatusTag } from 'components/pages/crm-spot/shared-components/status-tag';
import dayjs from 'dayjs';

export const TaskTable = ({ tasks, updateUserTaskStatus }) => {
  // const [selectTask, setSelectTask] = useState([]);
  // Add a single task ID
  // const manageTaskSelection = (id) => {
  //   setSelectTask((prev) => (prev.includes(id) ? prev.filter((taskId) => taskId !== id) : [...prev, id]));
  // };

  // Add all task IDs from a given array
  // const handleAllTask = () => {
  //   if (selectTask.length === tasks.length) {
  //     setSelectTask([]);
  //   } else {
  //     setSelectTask(tasks.map((task) => task.id));
  //   }
  // };

  const handleTaskStatus = async (taskId, status) => {
    await updateUserTaskStatus(taskId, status);
  };

  const columns = [
    // {
    //   title: <Checkbox onChange={handleAllTask} checked={selectTask.length === tasks.length && tasks.length > 0} />,
    //   dataIndex: 'id',
    //   render: (id) => <Checkbox checked={selectTask.includes(id)} onChange={() => manageTaskSelection(id)} />,
    //   width: 50,
    // },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (status, record) => {
        const isPending = status === 'pending';
        const isOverdue = isPending && record.due_date && dayjs(record.due_date).isBefore(dayjs(), 'day');
        return isOverdue ? <StatusTag status="overdue" /> : <StatusTag status={status} />;
      },
    },
    {
      title: 'Task',
      dataIndex: 'task',
    },
    {
      title: 'Lead',
      dataIndex: 'lead_id',
    },
    {
      title: 'Due Date',
      dataIndex: 'due_date',
      sorter: true,
      render: (date) => (date ? dayjs(date).format('MM-DD-YYYY') : ''),
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      sorter: true,
      render: (date) => (date ? dayjs(date).format('MM-DD-YYYY') : ''),
    },
    {
      title: 'Completed',
      dataIndex: 'status',
      render: (status, record) => (
        <Checkbox
          checked={status === 'completed'}
          onChange={() => handleTaskStatus(record.id, status === 'completed' ? 'pending' : 'completed')}
        />
      ),
      width: 50,
    },
  ];

  const [taskFilter, setTaskFilter] = useState('Active Tasks'); // pending or completed

  const showPendingTasks = taskFilter === 'Active Tasks';

  return (
    <>
      <Segmented
        options={['Active Tasks', 'Completed Tasks']}
        onChange={(value) => setTaskFilter(value)}
        block
        style={{ marginBottom: '1rem' }}
      />
      <Table
        rowKey="id"
        dataSource={tasks[showPendingTasks ? 'pending' : 'completed']}
        columns={columns}
        pagination={false}
      />
    </>
  );
};
